<script>
/* jshint esversion: 6 */
import {watch, computed} from 'vue';
import './../func.common';
import { FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default{
    name: 'TextAreaField',
    components: {
        'font-awesome-icon' : FontAwesomeIcon
    },
    props: {
        'disabled': {type: Boolean},
        'hinted': {type: String},
        'id': { type: String, default: ''}, 
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'schemaId': {type: Number, default: 0}, 
    },
    emits: ['validateChild', 'buttonClickParent'],
    setup(props,ctx) {
        const helperName = computed(() => {
            return props.model[props.schema.model];
        });

        watch(helperName, (newVal, oldVal) => {
            var toParent = {
                'id': props.schemaId,
                'model': props.schema.model,
                'validator': props.schema.validator,
                'vTxext': props.schema.validatorText
            };
            ctx.emit('validateChild', toParent);
        });

        return {
            helperName
        };
    }
};
</script>
<template lang="pug">
.vueFormFieldMain
    .fieldTextArea(
       :class="[schema.class,disabled === true ? 'fieldDisabled' : ''] "
    )
        .form-group.row.gy-2.gx-3-align-items-left
            .col-sm-12 
                label(
                    :for="id" 
                    v-if="schema.label && schema.label.length > 0"
                ) 
                    |{{ schema.label }}
                    span.redAst(v-if="schema.required === true") *
        .form-group.row.gx-3-align-items-left(:style="disabled === true ? 'opacity: 0.5; cursor:not-allowed' :''")
            .col-sm-12
                textarea.form-control(
                    :id="id" 
                    :type="schema.inputType" 
                    :name="schema.model" 
                    v-model="model[schema.model]" 
                    :class="[schema.errorShow === true ? 'inputred' : '', , model[schema.model] !== '' ? 'getWhite' : 'getBlue']"
                    :rows="schema.row"
                    :style="disabled === true ? 'pointer-events:none' : ''"
                )
        .hint(v-if="hinted && hinted.length > 0" v-html="hinted") 
        .vueFormSmall.labelred(v-if="schema.errorShow === true")
            font-awesome-icon(icon="fa-solid fa-exclamation" class="errorExclamationMarkColor") 
            | &nbsp;{{ schema.errorText[0] }}
</template>